export default __webpack_public_path__ + "static/media/third_send.38c314eb.png";